import dateFromArgs from '../helpers/date-from-args';

export default function isDate(value) {
  // hack:
  // we will allow unsupported browsers to use yyyy-mm-dd format directly
  // (other browsers translate input date value into that string)
  // force entered value into yyyy-mm-dd format as the rest of browsers
  let probablyValid = true;
  const s = value.split('-');
  const y = s[0];
  const m = s[1];
  const d = s[2];
  if (
    !!(s.length !== 3)
    || !/^\d{4}$/i.test(y)
    || !/^\d{2}$/i.test(m)
    || !/^\d{2}$/i.test(d)
  ) {
    probablyValid = false;
  }

  const intYear = parseInt(y, 10);
  const intMonth = parseInt(m, 10);
  const intDay = parseInt(d, 10);

  // also check final month is the same as the one written by user, since we're
  // not using the native date calendar on android we could potentially write
  // 31 february and android would convert to 2nd march
  const dateMonthIndex = dateFromArgs(intYear, intMonth, intDay).getUTCMonth();

  if (dateMonthIndex !== intMonth - 1) {
    probablyValid = false;
  }

  return probablyValid;
}
